export default "__VITE_ASSET__31e8ba37__"